import { Asterisk } from "lucide-react";

const WORDS = [
  "AI-Native",
  "Billing",
  "Inventory",
  "Intelligence",
  "Automation",
  "Real Business",
  "Insights",
  "Decisions",
];

// Slow editorial marquee. Duplicated once for a seamless -50% loop.
export const Marquee = () => {
  const items = [...WORDS, ...WORDS];
  return (
    <section
      data-testid="marquee-section"
      className="relative border-y border-black/[0.06] bg-[#fafafa] py-8"
      aria-hidden="true"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-[#fafafa] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-[#fafafa] to-transparent" />
      <div className="flex w-max animate-marquee items-center">
        {items.map((word, i) => (
          <div key={i} className="flex items-center">
            <span className="whitespace-nowrap px-8 font-heading text-2xl font-medium tracking-tight text-[#0a0a0a] sm:text-3xl">
              {word}
            </span>
            <Asterisk className="h-5 w-5 text-brand-teal" />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
